import {
    LIST_EVENTS_SUCCESS,
    LIST_EVENTS_FAILURE,
    UPDATE_EVENTS_FILTER,
    OPEN_EVENT_DETAIL_DIALOG,
    CLOSE_EVENT_DETAIL_DIALOG
} from './EventActionTypes'

export const initialEventState = () => ({
    eventList: null,
    eventListFilter: {
        from: "",
        before: "",
        careUnitOrganizationId: "",
        opticianOrganizationId: "",
        eventType: "",
    },
    errorMessage: null,
    isLoading: false,
    selectedEvent: null,
    detailDialogOpen: false,
    currentPage: 0,
    totalPages: 0,
    totalElements: 0,
    statusCounts: {},
});

const eventLog = (state = initialEventState(), action) => {
    switch (action.type) {
        case LIST_EVENTS_SUCCESS:
            return {
                ...state,
                eventList: action.events.content,
                currentPage: action.events.currentPage,
                totalPages: action.events.totalPages,
                totalElements: action.events.totalElements,
                statusCounts: action.events.statusCounts || {},
                errorMessage: null,
            }
        case LIST_EVENTS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
            }
        case UPDATE_EVENTS_FILTER:
            return {
                ...state,
                eventListFilter: action.filter,
            }
        case OPEN_EVENT_DETAIL_DIALOG:
            return {
                ...state,
                selectedEvent: action.event,
                detailDialogOpen: true,
            }
        case CLOSE_EVENT_DETAIL_DIALOG:
            return {
                ...state,
                selectedEvent: null,
                detailDialogOpen: false,
            }
        default:
            return state;
    }
}
export default eventLog;